import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Stack } from '@mui/material';
import { FC } from 'react';

export const SingleLayout: FC<{ layout: Layout }> = ({ layout }) => {
	if (!layout) return null;

	return (
		<>
			<LayoutSlot slot={layout.slots.header} />
			<Stack component="main" sx={layoutMainSX(layout.slots.first?.length || 0)}>
				<LayoutSlot slot={layout.slots.first} />
				<LayoutSlot slot={layout.slots.footer} />
			</Stack>
		</>
	);
};
